import React, { type FC, useEffect, useState } from 'react';

import FilterIcon from '@lt/components/icons-react/rebrand/Filter';
import { useTranslation } from '@lt/localization';
import { useShowFilters } from '../../../store/flights-filters';

import styles from './ShowFiltersButton.module.css';

interface IShowFiltersButton {
  filtersCount: number;
  isMobile?: boolean;
  toggleFiltersPanel: () => void;
  areInitialFlightsFetchingDone: boolean;
  isModalShown: boolean;
}

const ShowFiltersButton: FC<IShowFiltersButton> = ({
  isMobile = false,
  filtersCount,
  toggleFiltersPanel,
  areInitialFlightsFetchingDone,
  isModalShown,
}) => {
  const { t } = useTranslation();
  const [showButton, setShowButton] = useState(false);
  const [showFilters] = useShowFilters();

  useEffect(
    () => setShowButton(Boolean(showFilters)),
    [showButton, showFilters],
  );

  const visible = Boolean(
    isMobile && areInitialFlightsFetchingDone && showButton && !isModalShown,
  );

  if (!visible) return null;

  return (
    <div className={styles.container}>
      <button
        className={styles.button}
        type="button"
        onClick={toggleFiltersPanel}
      >
        <div>
          {Boolean(filtersCount) && (
            <div className={styles.filtersCount}>{filtersCount}</div>
          )}
          <FilterIcon height={16} />
        </div>
        <p className={styles.text}>{t('checkout.flight.filtersButton')}</p>
      </button>
    </div>
  );
};

export default ShowFiltersButton;
